import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { useAuth } from "../AuthContext";
import { formatApiError } from "../../lib/adminApi";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido a Velarias Tens Admin");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err, "No se pudo iniciar sesión"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative bg-eclipse flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="/images/vt_hero_velarias_tens.jpg"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-eclipse via-eclipse/80 to-navy-600" />
      </div>

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-start gap-3 mb-10">
          <img src="/images/brand/vt_logo_lightbg.png" alt="Velarias Tens" className="h-20 w-auto" />
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#3D5311]">CRM · Panel interno</p>
        </div>

        <div className="bg-white border border-[#DDE2D5] p-8 md:p-10 backdrop-blur">
          <div className="flex items-center gap-3 mb-2">
            <span className="divider-accent" />
            <span className="kicker">Acceso restringido</span>
          </div>
          <h1 className="font-display font-black text-3xl md:text-4xl tracking-tightest leading-tight">
            Inicia sesión
          </h1>
          <p className="mt-3 text-[#4B5563] text-sm">
            Solo personal autorizado de Eclipse Cubiertas.
          </p>

          <form onSubmit={onSubmit} className="mt-8 space-y-4" noValidate data-testid="admin-login-form">
            <label className="block">
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#4B5563]">Email</span>
              <div className="mt-2 relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                <input
                  type="email"
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@velariastens.com"
                  className="w-full bg-white border border-[#DDE2D5] pl-10 pr-4 py-4 text-[#1F2937] placeholder:text-[#6B7280] focus:outline-none focus:border-accent"
                  data-testid="admin-login-email"
                />
              </div>
            </label>

            <label className="block">
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#4B5563]">Contraseña</span>
              <div className="mt-2 relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full bg-white border border-[#DDE2D5] pl-10 pr-4 py-4 text-[#1F2937] placeholder:text-[#6B7280] focus:outline-none focus:border-accent"
                  data-testid="admin-login-password"
                />
              </div>
            </label>

            <button
              type="submit"
              disabled={loading}
              className="btn-accent w-full justify-center disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? "Ingresando…" : <>Ingresar <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-[#9CA3AF] font-mono text-[11px] uppercase tracking-widest">
          Eclipse Cubiertas SA de CV · Monterrey, MX
        </p>
      </div>
    </div>
  );
}
